// 现代化确认对话框组件
import React from 'react';
import { X } from 'lucide-react';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  type?: 'danger' | 'warning' | 'info';
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  type = 'danger'
}) => {
  if (!isOpen) return null;

  const getTypeStyles = () => {
    switch (type) {
      case 'danger':
        return {
          confirmButton: 'ai-confirm-button-danger'
        };
      case 'warning':
        return {
          confirmButton: 'ai-confirm-button-warning'
        };
      default:
        return {
          confirmButton: 'ai-confirm-button-info'
        };
    }
  };

  const styles = getTypeStyles();

  return (
    <div className="ai-modal-overlay">
      <div className="ai-modal-container">
        <div className="ai-confirm-dialog">
          <div className="ai-confirm-header">
            <h3 className="ai-confirm-title">{title}</h3>
            <button onClick={onCancel} className="ai-confirm-close">
              <X className="h-5 w-5" />
            </button>
          </div>
          
          <div className="ai-confirm-content">
            <p className="ai-confirm-message">{message}</p>
          </div>
          
          <div className="ai-confirm-actions">
            {cancelText && (
              <button
                onClick={onCancel}
                className="ai-confirm-button-cancel"
              >
                {cancelText}
              </button>
            )}
            <button
              onClick={onConfirm}
              className={`ai-confirm-button ${styles.confirmButton}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;